import { MsalProvider } from '@azure/msal-react';
import { EventType } from '@azure/msal-browser';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { msalInstance } from './auth/msalConfig';
import './styles/globals.css';

/**
 * Bootstrap MSAL :
 *  - On INITIALISE l'instance (obligatoire en v3+).
 *  - On gère le retour de redirect (handleRedirectPromise).
 *  - On définit le compte actif quand un login réussit.
 *  - Puis seulement, on monte React.
 */
async function bootstrap() {
  await msalInstance.initialize();

  // Récupère le résultat d'un éventuel redirect (login retour)
  const response = await msalInstance.handleRedirectPromise();
  if (response?.account) {
    msalInstance.setActiveAccount(response.account);
  } else if (msalInstance.getAllAccounts().length > 0 && !msalInstance.getActiveAccount()) {
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  }

  // Garde l'active account synchro après n'importe quel login ultérieur
  msalInstance.addEventCallback(event => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload && 'account' in event.payload) {
      const account = (event.payload as { account: import('@azure/msal-browser').AccountInfo }).account;
      msalInstance.setActiveAccount(account);
    }
  });

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <MsalProvider instance={msalInstance}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MsalProvider>
    </StrictMode>
  );
}

bootstrap().catch(err => {
  console.error('MSAL bootstrap failed', err);
  // Affichage minimal d'urgence
  document.getElementById('root')!.innerHTML =
    '<div style="font-family:sans-serif;padding:2rem;text-align:center;">'
    + '<h1>Erreur de connexion</h1>'
    + '<p>Recharge la page. Si le problème persiste, contacte ton administrateur.</p>'
    + '</div>';
});
